import TrendChartSkeleton from '@/components/molecules/TrendChart/Skeleton';

const LIMIT = 6;

const Empty = () => (
  <div className='h-[167px] w-[188px]'>
    <TrendChartSkeleton />
  </div>
);

const Skeleton = () => {
  return (
    <div className='flex items-center gap-[6px] overflow-scroll px-5 py-4 pb-6 pt-4'>
      {Array.from({ length: LIMIT })
        .fill(0)
        .map((_, index) => (
          <div className='w-[188px]' key={`trend-chart-$${index}`}>
            <Empty />
          </div>
        ))}
    </div>
  );
};

export default Skeleton;
